export function seo(data = {}) {
    data.title = data.title || 'Campboard';
    //data.metaDescription = data.metaDescription || 'Campboard';
  
    document.title = data.title;
    //document.querySelector('meta[name="description"]').setAttribute('content', data.metaDescription);
}